// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'archive-solid';

export const Component = () => (
  <path d='M23.173 5.927H12.78V2h5.03c.382 0 .67.096.91.335l4.31 3.4c.047.049.096.145.143.192Zm-11.398 0V2H6.746c-.383 0-.67.096-.91.335l-4.263 3.4a.372.372 0 0 0-.191.192h10.393Zm11.782.958H12.781v3.449c0 .335-.144.479-.479.479-.335 0-.526-.144-.526-.48V6.886H1V21.11c0 .432.144.767.431 1.054.288.288.623.432 1.054.432h19.588c.336 0 .72-.144 1.054-.432.288-.287.432-.622.432-1.054V6.885h-.002Z' />
);

export const viewBox = '0 0 25 25';
